export default "__VITE_ASSET__Cj9$ekWf__"